import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import * as R from 'ramda'
import moment from 'moment'

import CommentCard from './CommentCard'
import CommentForm from './CommentForm'
import ReplyButton from './ReplyButton'
import Section from './SectionDiscussion'
import commentActions from 'actions/commentActions'
import { commentText } from 'utils/commentsText'


import { objectComments } from 'selectors/comments'
import { currentUser } from 'selectors/common'
import { notificationsByPropertyID } from 'selectors/notifications'
import { properties } from 'selectors/entities'

let select = (state, props) => ({
	comment: state.commentBuffer
  , accordion: state.accordion
  , currentUser: currentUser(state)
  , expanded: state.sections['group'+props.group[0].objectID] !== undefined ? state.sections['group'+props.group[0].objectID] : false
  , properties: properties(state)
})

const url={
	'transaction/invoice': "transaction",
	'transaction/bill': "transaction"
}

let description = obj => {
	if(obj.type == 'property'){
		return ''
	} else if(obj.type == 'project') {
		return obj.title.split(',')[0]
	} else if(obj.type == 'task') {
		return obj.taskContent //obj.projectName.split(',')[0] + ": " + obj.taskContent
	} else if(obj.type == 'listing') {
		return "Listing $" + obj.rent + " " + obj.dateFrom + " " + obj.dateTill
	} else if(obj.type == 'application') {
		return "Application $" + obj.rent + " " + obj.primaryResident.firstName + " " + obj.primaryResident.lastName + " " + moment(obj.date).format("YYYY-MM-DD")
	} else if(obj.type == 'owner') {
		return "Property unrelated questions"
	} else {
		return obj.type
	}
}

export class CommentList extends Component {
	render(){
		let { props } = this
		let objectID = props.group[0].objectID
		let unread = R.filter(x=>!x.read && x.from!=props.currentUser)(props.group);
		if (props.expanded){
			R.map(notif=>this.props.COMMENT_READ({_id: notif._id}))(unread);
		}
		return(
			<Section
				id={"group"+objectID}
				accordionID={"group"+objectID}
				badge={unread && unread.length || 0}
				notificationID = {props.notificationID}
				title={
					<div style={{width: "100%", height:"20px", whiteSpace:"nowrap"}}>
						{props.group[0] && props.group[0].object && props.group[0].object.type!=="owner" && props.accordion==("group"+objectID) && props.expanded && (!props.properties[props.objectID] || props.group[0].property!=props.properties[props.objectID].alias)?
						<Link
							style={{
								display:"inline-block"
							  , lineHeight:"20px"
							  , paddingLeft:"0px"
							  , fontWeight:unread && unread.length ?"600":"400"
							  , color: 'black'
							}}
							to={"/landlord/"+(url[props.group[0].object.type] || props.group[0].object.type)+"/"+props.group[0].object._id}
						>
							{props.group[0].property}
						</Link>
						:<div
							style={{
								display:"inline-block"
							  , lineHeight:"20px"
							  , paddingLeft:"0px"
							  , fontWeight:unread && unread.length ?"600":"400"
							//   , background: "rgb(170, 255, 234)"
							  , float: "left"
							}}
						>
							{!props.group[0].property?"":props.group[0].property + ","}
						</div>}
						<div
							style={{
								display:"inline-block"
							  , lineHeight:"20px"
							  , paddingLeft:props.group[0].object && props.group[0].object.type=="owner"?"0":"5px"
							  , fontWeight:unread && unread.length?"600":"400"
							}}
						>
							{props.group[0].object && props.group[0].object.type!=="owner" && props.accordion==("group"+objectID) && props.expanded ?
								<Link
									to={"/landlord/"+(url[props.group[0].object.type] || props.group[0].object.type)+"/"+props.group[0].object._id}
									style={{
										color: 'black'
										, display:"inline-block"
										, fontWeight:unread && unread.length?"600":"400"
									}}
								>
									{description(props.group[0].object)}
								</Link>
								:
								<span style={{fontWeight:unread && unread.length?"600":"400"}}>{description(props.group[0].object)}<span style={{color:"rgb(158,158,158)", fontWeight:unread && unread.length?"600":"400"}}> – {commentText(props.group[0].comment.contents)}</span></span>
							}
						</div>
					</div>
				}
				rightButton={<ReplyButton objectID={objectID}/>}
			>
				<div style={{paddingLeft:"0px"}}>
					{ (props.comment.objectID == objectID) && <CommentForm objectID={objectID} path={props.path} />}
					{props.group.map(notifiaction => (props.comment.commentID != notifiaction.comment._id)?<CommentCard notifiactionID={notifiaction._id} commentID={notifiaction.comment._id}/> : <CommentForm objectID={objectID} path={props.path}/>)}
				</div>
			</Section>


		)
	}
}

export default connect(select, commentActions)(CommentList)



// WEBPACK FOOTER //
// ./src/components/Communication/CommentList.js